var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPin = function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.143v12.824l5.065-2.17 6 3L18 16.68V3.857l1.303-.558a.5.5 0 0 1 .697.46V18l-7 3-6-3-6.303 2.701a.501.501 0 0 1-.697-.46V6l2-.857Zm12.243 5.1L10 14.485l-4.243-4.242a6 6 0 1 1 8.486 0ZM10 11.657l2.828-2.829a4 4 0 1 0-5.656 0L10 11.657Z",
    fill: "#E96358"
  })));
};
export default SvgMapPin;